export const AccountConfig = {
  minWeight: 0,
  maxWeight: 255,
  maxOwnerWithNonce: 9,
  maxOwnerWithoutNonce: 10,
  nonce: {
    prefix: 'maven',
    weight: 1,
    maxSize: 16,
  },
};

export const SUI_COIN = '0x2::sui::SUI';
export const UNKNOWN_COIN = 'UNKNOWN COIN';
